export default "__VITE_ASSET__CIamc3jb__"